"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const OfficeLightResponseResource_1 = __importDefault(require("../Office/OfficeLightResponseResource"));
const Resource_1 = __importDefault(require("../Resource"));
const RoleResponseRessource_1 = __importDefault(require("../Role/RoleResponseRessource"));
const UserToFileResponseResource_1 = __importDefault(require("./File/UserToFileResponseResource"));
class UserPublicResponseResource extends Resource_1.default {
    constructor() {
        super(...arguments);
        this.userToFiles = [];
    }
}
exports.default = UserPublicResponseResource;
__decorate([
    (0, class_validator_1.IsUUID)(4),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], UserPublicResponseResource.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], UserPublicResponseResource.prototype, "lastName", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], UserPublicResponseResource.prototype, "firstName", void 0);
__decorate([
    (0, class_validator_1.IsEmail)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], UserPublicResponseResource.prototype, "email", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], UserPublicResponseResource.prototype, "phoneNumber", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => RoleResponseRessource_1.default),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", RoleResponseRessource_1.default)
], UserPublicResponseResource.prototype, "role", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => OfficeLightResponseResource_1.default),
    __metadata("design:type", Array)
], UserPublicResponseResource.prototype, "offices", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], UserPublicResponseResource.prototype, "createdAt", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], UserPublicResponseResource.prototype, "lastLoginAt", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], UserPublicResponseResource.prototype, "nbOfSubscriptions", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => UserToFileResponseResource_1.default),
    __metadata("design:type", Array)
], UserPublicResponseResource.prototype, "userToFiles", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], UserPublicResponseResource.prototype, "etatCompte", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], UserPublicResponseResource.prototype, "birthDate", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], UserPublicResponseResource.prototype, "dateSignatureConvention", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], UserPublicResponseResource.prototype, "dateCreationCompte", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], UserPublicResponseResource.prototype, "preRegistredAt", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], UserPublicResponseResource.prototype, "reminderEmailSentAt", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], UserPublicResponseResource.prototype, "registeredAt", void 0);
